// extracted by mini-css-extract-plugin
module.exports = {"center":"loading-center_center__mXGP5"};